/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagefiltertypeall4Inputs */

const en_ticketpagefiltertypeall4 = /** @type {(inputs: Ticketpagefiltertypeall4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All ticket types`)
};

const de_ticketpagefiltertypeall4 = /** @type {(inputs: Ticketpagefiltertypeall4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ticketarten`)
};

/**
* | output |
* | --- |
* | "All ticket types" |
*
* @param {Ticketpagefiltertypeall4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefiltertypeall4 = /** @type {((inputs?: Ticketpagefiltertypeall4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefiltertypeall4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefiltertypeall4(inputs)
	return de_ticketpagefiltertypeall4(inputs)
});
export { ticketpagefiltertypeall4 as "ticketPageFilterTypeAll" }